import React, { useState, useEffect } from "react";
import dayjs from 'dayjs';
import { getSimulations } from "../../../api/user";
import { DatePicker,Button,notification,Space } from 'antd';
import { getAccessTokenApi } from "../../../api/auth";
import { get } from "../../../api/get";
import ListOutputs from "../../../components/Admin/Users/ListOutputs";
import moment from 'moment';
import {useDate} from "../../../hooks"

import "./Outputs.scss";

export default function Outputs() {
  const { RangePicker } = DatePicker;
  const{date,setDate,}=useDate();
  const [simulations, setSimulations] = useState([]); //Todos los usuarios
  const [datetime, setdatetime] = useState([]); //Todos los usuarios
  const [datewindow, setdatewindow] = useState([]); //Todos los usuarios

  const [rangeName, setRangeName] = useState('Showing last 24 hours simulations');
  const [reloadUsers, setReloadUsers] = useState(false);
  const token = getAccessTokenApi();


  useEffect(() => {
    get('get-simulaciones','get-simulaciones','').then((response) => {
    // getSimulations(token).then((response) => {
      // console.log("Simulaciones");
      // console.log(response.simulaciones_del_usuario);
      // console.log("--------");
      var auxi=response.simulaciones_del_usuario
      // console.log(auxi.length,' ',String(auxi[0].horaInput).replace('-',' '))
      // const firstEpoch = new Date(String(datewindow[0])).getTime();
      const firstEpoch = moment(String(date[0])).unix()*1000;
      // const secondEpoch = new Date(String(datewindow[1])).getTime();
      const secondEpoch = moment(String(date[1])).unix()*1000+86400000;
      // console.log(firstEpoch,secondEpoch)
      
      auxi=auxi.reverse()
      if(date[0]===undefined || date[1]===undefined){
        setRangeName('Showing last 24 hours simulations')
        var aux=[]
        for(var i = 0;i<auxi.length;i++){
          const actual = moment().subtract(1, 'd').format();
          const firstEpoch = moment(String(actual)).unix()*1000;
          const simulationEpoch = moment(String(auxi[i].horaInput).replace('-',' ')).unix()*1000;
          if(simulationEpoch>=firstEpoch){
            aux=[...aux,auxi[i]]
          }
        }
      }else{
        setRangeName(`Range choosen: ${date[0]}-${date[1]}`)
        var aux=[]
        for(var i = 0;i<auxi.length;i++){
          // const simulationEpoch = new Date(String(auxi[i].horaInput).replace('-',' ')).getTime();
          const simulationEpoch = moment(String(auxi[i].horaInput).replace('-',' ')).unix()*1000;
          // console.log('============================================='); // 1663574293
          // console.log(simulationEpoch,' ',String(auxi[i].horaInput).replace('-',' ')); // 1663574293
          // console.log(moment(String(datewindow[0])).unix()*1000,' ',String(datewindow[0])); // 1663574293
          // console.log(moment(String(datewindow[1])).unix()*1000,' ',String(datewindow[1]));
          if(simulationEpoch>=firstEpoch && simulationEpoch<=secondEpoch){
            aux=[...aux,auxi[i]]
          }
        }
      }
      
      // console.log(moment(String(datewindow[0])).unix()*1000); // 1663574293
      // console.log(moment(String(datewindow[1])).unix()*1000); // 1663574293
      // console.log(firstEpoch); // 1663574293
      // console.log(String(datewindow[1])); // 1663574293
      // console.log(secondEpoch); // 1663574293
      // console.log(aux)
      // console.log(date[0]===undefined)
      // console.log(String(date[0]))

      setSimulations(aux);
      
    });

    setReloadUsers(false);
  }, [token, reloadUsers,date]); //Solo se refresca si cambian estos

  const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current > dayjs().endOf('day');
  };

  const disabledDateTime = () => ({
    disabledHours: () => range(0, 24).splice(4, 20),
    disabledMinutes: () => range(30, 60),
    disabledSeconds: () => [55, 56],
  });

  const disabledRangeTime = (_, type) => {
    if (type === 'start') {
      return {
        disabledHours: () => range(0, 60).splice(4, 20),
        disabledMinutes: () => range(30, 60),
        disabledSeconds: () => [55, 56],
      };
    }
    return {
      disabledHours: () => range(0, 60).splice(20, 4),
      disabledMinutes: () => range(0, 31),
      disabledSeconds: () => [55, 56],
    };
  };



  return (
    <>
      <h1 className="titulos1">SIMULATIONS</h1>
      <h2 style={{fontFamily: 'report-bold'}}>Select the time window of simulations you want to show and click 'Upload'. </h2>
      <div style={{display:'flex',alignItems:'center'}}>
      {/* <div style={{width:'300px',}}> */}
        <RangePicker 
          disabledDate={disabledDate}
          disabledTime={disabledDateTime}
          onChange={(value)=>{
          setdatetime(value)
        }}/>
      {/* </div> */}
      <Button className="boton"
        type="primary"
        style={{borderColor: "rgb(35,148,212)", 
        borderWidth:'2px',
        color:'rgb(0,104,178)',
        fontFamily:'report',
        fontSize:'17px',
        marginLeft:'20px',
        marginRight:'20px',
        backgroundColor: "white" }}
        onClick={() => {
          if(datetime==null){
            notification["error"]({
              message: `Error`,
              description:'Select a time window'
            });
          }else{
            var fecha1
            var fecha2
            var timewindow1=String(datetime[0]).split(' ');
            var timewindow2=String(datetime[1]).split(' ');
            var mes1
            var mes2
            // console.log('ahi va1:',timewindow1);
            (timewindow1[1]==='Jan')
            ?mes1='01'
            :(timewindow1[1]==='Feb')
            ?mes1='02'
            :(timewindow1[1]==='Mar')
            ?mes1='03'
            :(timewindow1[1]==='Apr')
            ?mes1='04'
            :(timewindow1[1]==='May')
            ?mes1='05'
            :(timewindow1[1]==='Jun')
            ?mes1='06'
            :(timewindow1[1]==='Jul')
            ?mes1='07'
            :(timewindow1[1]==='Aug')
            ?mes1='08'
            :(timewindow1[1]==='Sep')
            ?mes1='09'
            :(timewindow1[1]==='Oct')
            ?mes1='10'
            :(timewindow1[1]==='Nov')
            ?mes1='11'
            :(timewindow1[1]==='Dec')
            ?mes1='12'
            :mes1='01'
            
            console.log('ahi va1:',timewindow2);
            (timewindow2[1]==='Jan')
            ?mes2='01'
            :(timewindow2[1]==='Feb')
            ?mes2='02'
            :(timewindow2[1]==='Mar')
            ?mes2='03'
            :(timewindow2[1]==='Apr')
            ?mes2='04'
            :(timewindow2[1]==='May')
            ?mes2='05'
            :(timewindow2[1]==='Jun')
            ?mes2='06'
            :(timewindow2[1]==='Jul')
            ?mes2='07'
            :(timewindow2[1]==='Aug')
            ?mes2='08'
            :(timewindow2[1]==='Sep')
            ?mes2='09'
            :(timewindow2[1]==='Oct')
            ?mes2='10'
            :(timewindow2[1]==='Nov')
            ?mes2='11'
            :(timewindow2[1]==='Dec')
            ?mes2='12'
            :mes2='01'

            console.log('ahi mes2:',mes2);
            fecha1=timewindow1[3]+'/'+mes1+'/'+timewindow1[2]
            fecha2=timewindow2[3]+'/'+mes2+'/'+timewindow2[2]
            // console.log('ahi va2:',fecha2);
            // setdatewindow([fecha1,fecha2])
            setDate([fecha1,fecha2])
          }
          
        }}>
        Upload
      </Button>
      <h1 style={{marginTop:'8px',
        fontFamily:'report'}}>{rangeName}</h1>
      </div>
      <h2 style={{marginTop:'10px',fontFamily: 'report-bold'}}>Click the orange ↻ buttom to get the output simulation or click the blue 🔎 buttom to show the results. </h2>
      <div style={{border: '5px solid rgb(203,234,247)'}}>
      
        <ListOutputs 
          simulations={simulations}
          setReloadUsers={setReloadUsers}
        />
      </div>
    </>
  );
}
